import { Navigate } from 'react-router-dom';

import SingleCardTemplate from '@/components/layouts/SingleCardTemplate';
import AccountRegistrationEmailSent from '@/features/registration/components/AccountRegistrationEmailSent';

interface Props {
  email: string;
  isFetching: boolean;
  onResend: () => void;
  onGoBack: () => void;
}

const AccountRegistrationEmailSendPage: React.FC<Props> = ({
  email,
  isFetching,
  onResend,
  onGoBack,
}) =>
  !email ? (
    <Navigate replace to="/registration" />
  ) : (
    <SingleCardTemplate title="アカウントの仮登録">
      <AccountRegistrationEmailSent
        email={email}
        isFetching={isFetching}
        onResend={onResend}
        onCancel={onGoBack}
      />
    </SingleCardTemplate>
  );

export default AccountRegistrationEmailSendPage;
